/** Packages * */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { DefaultButton } from '../Buttons/Buttons.jsx';
import { CardHeader } from '@material-ui/core';
import Pairing from './Pairing';
import * as utilities from './../../utilities/calendarUtilities';
import { common } from './../../data/constants';
import { fetchActivityDetails } from './../../data/calendarActivities/actions.js';
import AddRequest from '../OpenTimeSearch/components/AddRequest';
import { buildAddRequestData, isActivityStartsInBidSessionPeriod } from '../OpenTimeSearch/components/AddRequest/helpers';
import Reserve from './Reserve';
import { openTimeSearchConfig } from '../../settings/settings';
import { withStyles } from '@material-ui/core/styles';
import { useLanguage } from '../../context/LanguageContext';

const OkButton = withStyles({
  root: {
    backgroundColor: 'transparent',
    border: 'none',
    height: '40px',
    color: common.colors.CI_BLUE,
    textTransform: 'uppercase'
  }
})(DefaultButton);

const RemoveButton = withStyles({
  root: {
    backgroundColor: 'transparent',
    border: 'none',
    height: '40px',
    color: common.colors.CI_RED,
    textTransform: 'uppercase'
  }
})(DefaultButton);

const CalendarActivityDetails = props => {
  const { labels } = useLanguage();
  const calendarLabels = labels.calendarLabels || {};
  const [open, setOpen] = useState(false)
  const [details, setDetails] = useState({})

  useEffect(() => {
    fetchActivityDetails(props.activityId, props.stationId)()
      .then((response) => {
        setOpen(true)
        setDetails(response.data)
     }).catch(e => console.log(e.response));
  },[])

  const handlePreferenceAndClose = (response) => {
    const { handleActionPreference } = props;
    handleActionPreference(response, true);
    props.handleClose();
  }


    const { activity, bidSession, bidSession: { currentBid: { id: bidSessionId } }, bidPreferencesTotalEntries, showNotification } = props;
    const isActivityStartInSessionPeriod = isActivityStartsInBidSessionPeriod(activity, bidSession);
    const { label, isPreferenceOptionActive, requestPreferencePayload, isPairingOrReserve } = buildAddRequestData(activity, bidSession);

    const actions = [
      <OkButton
        className="ok-button"
        primary
        onClick={() => props.handleClose()}
      >
        {calendarLabels.details?.CLOSE_BTN}
      </OkButton>,
    ];

    if (props.isRemovable && isPairingOrReserve && isActivityStartInSessionPeriod && (isPreferenceOptionActive || bidSession.displayRequestOptions)) {
      actions.unshift(
        <AddRequest
          handleActionPreference={handlePreferenceAndClose}
          showNotification={showNotification}
          label={label}
          requestPreferencePayload={requestPreferencePayload}
          bidmode={bidSession.bidMode}
          bidSession={bidSession}
          setFromAddButton={props.setFromAddButton}
        />,
      );
    }

    if (props.isRemovable) {
      actions.unshift(
        <RemoveButton
          className="remove-button"
          primary
          onClick={() => props.handleRemove()}
        >
          {calendarLabels.details?.REMOVE_BTN}
        </RemoveButton>,
      );
    }
    const { activityType } = props;
    const isRSV = activityType === openTimeSearchConfig.activityTypes.RSV;
    const isTRP = activityType === openTimeSearchConfig.activityTypes.TRP;
    let content = '';
    if (Object.keys(details).length > 0) {
      if (isTRP) {
        content = (
          <Pairing
            pairing={details.pairing}
            name={details.activityName}
            days={details.days}
            startDate={details.startInterval}
            endDate={details.endInterval}
            nbSeniorOutbids={activity.nbSeniorOutbids}
            attributes={details.groupActivitiesType}
          />
        );
      } else if (isRSV) {
        content = (
          <Reserve
            name={details.activityName}
            startDate={details.startInterval}
            endDate={details.endInterval}
            nbSeniorOutbids={activity.nbSeniorOutbids}
            groupActivitiesType={details.groupActivitiesType}
          />
        );
      } else {
        content = `${details.activityName} ${utilities.convertActivityDetailsDateInterval(utilities.getUTC(details.startInterval), utilities.getUTC(details.endInterval))}`;
      }
    }
    return (
      <Dialog
        open={open}
        style={{ zIndex: 9999 }}
        maxWidth={'md'}
	      fullWidth
        scroll="paper"
      >
        <DialogTitle>
          <div className="no-margin">
            <CardHeader
              title={activityType}
              className="Calendar-Activity-Details-Title"
            />
          </div>
        </DialogTitle>
        <DialogContent>
          <div className="Calendar-Activity-Details-Content">
            {content}
          </div>
        </DialogContent>
        <DialogActions>
          {actions}
        </DialogActions>
      </Dialog>
    );
  }


CalendarActivityDetails.defaultProps = {
  stationId: '',
  setFromAddButton: () => {}
};

CalendarActivityDetails.propTypes = {
  bidSession: PropTypes.object.isRequired,
  activity: PropTypes.object.isRequired,
  handleClose: PropTypes.func.isRequired,
  handleRemove: PropTypes.func.isRequired,
  activityType: PropTypes.string.isRequired,
  stationId: PropTypes.string,
  activityId: PropTypes.number.isRequired,
  isRemovable: PropTypes.bool.isRequired,
  bidPreferencesTotalEntries: PropTypes.func.isRequired,
  handleActionPreference: PropTypes.func.isRequired,
  showNotification: PropTypes.func.isRequired,
  setFromAddButton: PropTypes.func
};

export default CalendarActivityDetails;
